// extracted by mini-css-extract-plugin
export default {"box":"Policy_box__kq-mX","icon_wrap":"Policy_icon_wrap__eWlM6","text":"Policy_text__pX+tn","description":"Policy_description__7x4SC"};